import { render } from "./Index.vue?vue&type=template&id=0d2e5ae1&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=0d2e5ae1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d2e5ae1"

export default script